import { AbstractControl } from "@angular/forms";

import {
	BBAN_PATTERNS,
	CHAR_CODE_A,
	CHAR_CODE_Z,
	MIN_IBAN_LENGTH,
	VALID_MOD_97_REMAINDER,
} from "./iban.validator.const";

const getCountryCode = (iban: string) => iban.substring(0, 2);

const getBban = (iban: string) => iban.substring(4);

const calculateMod97 = (iban: string) => {
	const shifted = iban.substring(4) + iban.substring(0, 4);

	const lettersConverted = shifted
		.split("")
		.map((n) => {
			const code = n.charCodeAt(0);
			if (CHAR_CODE_A <= code && code <= CHAR_CODE_Z) {
				// A = 10, B = 11, ... Z = 35
				return code - CHAR_CODE_A + 10;
			}
			return n;
		})
		.join("");

	let remainder = lettersConverted;
	let block;

	while (remainder.length > 2) {
		block = remainder.slice(0, 9);
		remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
	}

	return parseInt(remainder, 10) % 97;
};

export const ibanValidator =
	(allowedCountries?: string[]) =>
	(control: AbstractControl): { format?: boolean; country?: boolean } | null => {
		const iban = control.value;

		if (!iban) {
			return null;
		}

		if (iban.length < MIN_IBAN_LENGTH) {
			return { format: false };
		}

		const countryCode = getCountryCode(iban);
		if (allowedCountries && !allowedCountries.includes(countryCode)) {
			return { country: false };
		}

		const bbanPattern = BBAN_PATTERNS[countryCode];
		if (!bbanPattern) {
			return { format: false };
		}

		const bban = getBban(iban);
		if (!bbanPattern.test(bban)) {
			return { format: false };
		}

		if (calculateMod97(iban) !== VALID_MOD_97_REMAINDER) {
			return { format: false };
		}

		return null;
	};
